module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "preview",
    on: {
      "dragover": _vm.dragOver,
      "drop": _vm.drop
    }
  }, [_c('mu-paper', {
    staticClass: "preview-head"
  }, [_c('div', {
    staticClass: "bar"
  }, [_c('mu-sub-header', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v(_vm._s(_vm.showType))]), _vm._v(" "), _c('mu-icon-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": "fullscreen",
      "tooltip": "全屏"
    },
    on: {
      "click": _vm.fullScreen
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": "delete",
      "tooltip": "清空"
    },
    on: {
      "click": _vm.empty
    }
  }), _vm._v(" "), _c('mu-icon-menu', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": "stay_current_portrait",
      "tooltip": "视图",
      "targetOrigin": {
        vertical: 'bottom',
        horizontal: 'left'
      }
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "title": "调整比例"
    },
    on: {
      "click": _vm.setWidth
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": _vm.previewMode === 'pc' ? '手机模式' : 'PC模式'
    },
    on: {
      "click": function($event) {
        _vm.previewMode = _vm.previewMode === 'pc' ? 'mobile' : 'pc'
      }
    }
  })], 1), _vm._v(" "), _c('mu-icon-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": ":iconfont icon-css",
      "tooltip": "编辑样式"
    },
    on: {
      "click": _vm.editStyle
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": "code",
      "tooltip": "查看代码"
    },
    on: {
      "click": _vm.showCode
    }
  }), _vm._v(" "), (_vm.$store.state.backupComponents.length) ? _c('mu-icon-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": "undo",
      "tooltip": "撤销"
    },
    on: {
      "click": _vm.undo
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-content-block', {
    class: {
      'content': true, 'active': _vm.showType !== '预览'
    }
  }, [_c('pre', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showType === 'CODE'),
      expression: "showType==='CODE'"
    }, {
      name: "highlightjs",
      rawName: "v-highlightjs",
      value: (_vm.getSource(_vm.components)),
      expression: "getSource(components)"
    }]
  }, [_c('code', {
    staticClass: "html"
  })]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showType === '编辑样式'),
      expression: "showType==='编辑样式'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.css),
      expression: "css"
    }],
    staticClass: "css-editor",
    attrs: {
      "placeholder": ".vue-layout{ ... }"
    },
    domProps: {
      "value": (_vm.css)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.css = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.previewMode === 'pc'),
      expression: "previewMode==='pc'"
    }],
    ref: "preview",
    staticClass: "preview-area",
    on: {
      "click": _vm.clickPreview,
      "contextmenu": _vm.rightClick,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46])) { return null; }
        _vm.del($event)
      }
    }
  }, _vm._l((_vm.components), function(item, index) {
    return (!item.parentId) ? _c('div', {
      attrs: {
        "id": item.info.id
      }
    }) : _vm._e()
  })), _vm._v(" "), (_vm.previewMode === 'mobile') ? _c('iframe', {
    staticClass: "preview-mobile",
    attrs: {
      "src": "./#/preview/mobile"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.components.length === 0) ? _c('mu-content-block', {
    staticClass: "preview-tip"
  }, [_vm._v("\n        试试拖拽组件进来\n    ")]) : _vm._e(), _vm._v(" "), (_vm.current.info) ? _c('mu-popover', {
    attrs: {
      "trigger": _vm.popover.trigger,
      "open": _vm.popover.open
    },
    on: {
      "close": function($event) {
        _vm.popover.open = false
      }
    }
  }, [_c('mu-menu', {
    on: {
      "change": _vm.selectedSlot
    }
  }, [_c('label', [_vm._v("\n                  嵌套到" + _vm._s(_vm.current.info.name) + ":\n            ")]), _vm._v(" "), _vm._l((_vm.current.slots), function(val, key, index) {
    return _c('mu-menu-item', {
      key: index,
      attrs: {
        "title": key,
        "value": key
      }
    })
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "contextmenu",
    style: (_vm.contextmenu.style)
  }), _vm._v(" "), (_vm.current.info) ? _c('mu-popover', {
    attrs: {
      "anchorOrigin": {
        'vertical': 'top',
        'horizontal': 'middle'
      },
      "targetOrigin": {
        'vertical': 'top',
        'horizontal': 'left'
      },
      "trigger": _vm.contextmenu.trigger,
      "open": _vm.contextmenu.open
    },
    on: {
      "close": function($event) {
        _vm.contextmenu.open = false
      }
    }
  }, [_c('mu-content-block', [_vm._v(_vm._s(this.current.info.name))]), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-menu', {
    staticClass: "contextmenu",
    attrs: {
      "autoWidth": ""
    },
    on: {
      "itemClick": function($event) {
        _vm.contextmenu.open = false
      }
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "title": "复制"
    },
    on: {
      "click": _vm.copyComponent
    }
  }), _vm._v(" "), (_vm.$store.state.copiedComponents.length) ? _c('mu-menu-item', {
    attrs: {
      "title": "粘贴"
    },
    on: {
      "click": _vm.pasteComponent
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "删除"
    },
    on: {
      "click": _vm.del
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ed7cb0c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/preview.vue
// module id = 566
// module chunks = 1